function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { toError } from './parsers/error';
import { toSitesInfo, toUser, toManagerInfo } from './mappers/user';
export function initUser(settings, http) {
  /**
   * @summary Returns user
   * @memberof source.user
   * @param {String} userId
   * @param {Object} [options]
   * @returns {Promise}
   * @fulfill {User}
   * @reject {Error}
   */
  function getRequest(userId, options) {
    if (options === void 0) {
      options = {};
    }

    var queryParams = {};

    if (settings.namespace) {
      queryParams.ns = settings.namespace;
    }

    return http.get(settings.apiUrl + "/site/media/users/" + userId + "/info", queryParams, {
      headers: options.headers || {}
    }).then(function (res) {
      return _objectSpread({}, res, {
        data: toUser(res.data)
      });
    })["catch"](toError);
  }

  function getSitesInfo(options) {
    if (options === void 0) {
      options = {};
    }

    var queryParams = {};
    return http.get(settings.apiUrl + "/site/media/manager/user/info", queryParams, {
      headers: options.headers || {}
    }).then(function (res) {
      return _objectSpread({}, res, {
        data: toSitesInfo(res.data)
      });
    })["catch"](toError);
  }

  function getManagerInfo(options) {
    if (options === void 0) {
      options = {};
    }

    var queryParams = {};
    return http.get(settings.apiUrl + "/go/site/media/manager/info", queryParams, {
      headers: options.headers || {}
    }).then(function (res) {
      return _objectSpread({}, res, {
        data: toManagerInfo(res.data)
      });
    })["catch"](toError);
  }

  return {
    get: getRequest,
    getSitesInfo: getSitesInfo,
    getManagerInfo: getManagerInfo
  };
}